<template>
    <div>
        <div class="users-title">{{ $t('permission_configuration_management.user.userManagement') }}</div>
        <div class="users-top">
            <user-search></user-search>
        </div>
        <table-users></table-users>
    </div>
</template>

<script>
    import UserSearch from '../user/UserSearch'
    import TableUsers from '../user/TableUsers'
    export default {
        name: 'users',
        components: {
            UserSearch,
            TableUsers
        }
    }
</script>

<style scoped>
    .users-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .users-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/Users.vue